import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';
// import { LazyLoadImage } from 'react-lazy-load-image-component';

// import notFoundPage from '../assets/images/notfound-page.svg';
// import Header from '../layouts/commons/header/Header';
// import Footer from '../layouts/commons/footer/Footer';
import { getPathLanguage } from '../utils/params';

const NotFound = () => {
  const pathLanguage = getPathLanguage(useLocation());
  return (
    <>
      {/* <Header />
      <div className="not-found-page">
        <Link to={pathLanguage}>
          <LazyLoadImage className="not-found-img" alt="" src={notFoundPage} effect="blur" />
        </Link>
      </div>
      <Footer /> */}
      <Redirect to={pathLanguage} />
    </>
  );
};

export { NotFound };
